import { PropsWithClassName } from '@/types/shared';
import classNames from 'classnames';
import Link from 'next/link';

type Props = PropsWithClassName & {
  redirectUrl: null | string;
};

const ArrowRight = () => (
  <svg
    width='18'
    height='14'
    viewBox='0 0 18 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.707 0.305288L17.364 5.96229C17.5515 6.14982 17.6568 6.40412 17.6568 6.66929C17.6568 6.93445 17.5515 7.18876 17.364 7.37629L11.707 13.0333C11.5184 13.2154 11.2658 13.3162 11.0036 13.314C10.7414 13.3117 10.4906 13.2065 10.3052 13.0211C10.1198 12.8357 10.0146 12.5849 10.0123 12.3227C10.01 12.0605 10.1108 11.8079 10.293 11.6193L14.243 7.66929H1C0.734784 7.66929 0.48043 7.56393 0.292893 7.37639C0.105357 7.18886 0 6.9345 0 6.66929C0 6.40407 0.105357 6.14972 0.292893 5.96218C0.48043 5.77465 0.734784 5.66929 1 5.66929H14.243L10.293 1.71929C10.1975 1.62704 10.1213 1.5167 10.0689 1.39469C10.0165 1.27269 9.9889 1.14147 9.98775 1.00869C9.9866 0.87591 10.0119 0.744231 10.0622 0.621334C10.1125 0.498438 10.1867 0.386786 10.2806 0.292893C10.3745 0.199001 10.4861 0.124748 10.609 0.0744668C10.7319 0.0241859 10.8636 -0.00111606 10.9964 3.77564e-05C11.1292 0.00119157 11.2604 0.0287779 11.3824 0.0811869C11.5044 0.133596 11.6148 0.209778 11.707 0.305288Z'
      fill='black'
    />
  </svg>
);

export const BlogArticleReadMoreLink: React.FC<Props> = ({
  redirectUrl,
  className,
}) => {
  if (!redirectUrl) return null;

  return (
    <Link
      className={classNames('BlogArticleReadMoreLink', className)}
      href={redirectUrl}
    >
      <div className='flex items-center gap-1 font-bold'>
        Read More
        <ArrowRight />
      </div>
    </Link>
  );
};
